import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

/**
 * Invite bypass.
 *
 * Visiting `/enter` grants the visitor permanent (until they clear storage)
 * access to the full app even when LAUNCH_MODE=splash is on. Used to share
 * the app privately with early seekers while the public homepage still shows
 * the coming-soon splash.
 *
 * The flag is read in `App.js` to short-circuit the splash redirect for
 * subsequent visits to `/`.
 */
export const INVITE_KEY = "cor_invited";

export function hasInviteAccess() {
  try {
    return localStorage.getItem(INVITE_KEY) === "1";
  } catch {
    return false;
  }
}

export default function InviteEntry() {
  useEffect(() => {
    try { localStorage.setItem(INVITE_KEY, "1"); } catch (e) { if (process.env.NODE_ENV === "development") console.debug("[inviteentry] soft-fail:", e?.message); }
  }, []);
  return <Navigate to="/archive" replace />;
}
